import React from "react";
import { ArrowRight, Phone, Lightning } from "@phosphor-icons/react";

export default function FinalCTA() {
  return (
    <section id="final-cta" data-testid="final-cta-section" className="relative py-24 md:py-40 bg-[#0F0F0F] text-[#FFFFFF] overflow-hidden">
      <div className="absolute inset-0 opacity-[0.07]">
        <div className="absolute top-0 right-0 watermark text-[400px] select-none pointer-events-none" style={{ color: "#FFFFFF" }}>R</div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#FFFFFF]/20 backdrop-blur rounded-sm mb-6 border border-[#FFFFFF]/40">
          <Lightning size={14} weight="fill" className="text-[#FFFFFF]" />
          <span className="text-xs font-bold tracking-wider uppercase text-[#FFFFFF]">Kezdje el még ma</span>
        </div>

        <h2 className="font-display font-black text-5xl md:text-6xl lg:text-7xl xl:text-8xl tracking-tight leading-[0.9] text-balance mb-6">
          A garázsa már<br/>
          <span className="italic font-light text-[#FFFFFF]">1 hónap múlva</span> állhat.
        </h2>

        <p className="text-[#E4E4E7] text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Ne tologassa tovább. Kérjen ajánlatot most, és holnap már tudni fogja a fix árat.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#quote"
            data-testid="final-quote-btn"
            className="bg-[#FFFFFF] text-[#0F0F0F] hover:bg-[#FFFFFF] px-8 py-4 rounded-sm font-display font-bold text-base inline-flex items-center gap-2 transition-all hover:-translate-y-0.5"
          >
            Árajánlatot kérek <ArrowRight size={20} weight="bold" />
          </a>
          <a
            href="#callback"
            data-testid="final-callback-btn"
            className="bg-transparent border-2 border-[#FFFFFF] text-[#FFFFFF] hover:bg-[#FFFFFF] hover:text-[#0F0F0F] px-8 py-4 rounded-sm font-display font-bold text-base inline-flex items-center gap-2 transition-all"
          >
            <Phone size={20} weight="fill" /> Hívjanak vissza
          </a>
        </div>

        <div className="mt-10 text-sm text-[#E4E4E7]/80">
          420+ elégedett ügyfél · szerződéstől 1 hónap · 20 év garancia
        </div>
      </div>
    </section>
  );
}
